export default __webpack_public_path__ + "app/assets/images/logo/brand_basic_horizontal-d4382aa3dc21afdcd5ba6b04592be121.svg";